module.exports = __webpack_public_path__ + "static/media/prairie-wind.280920b6.bmp";